import React from 'react'
import { get } from "../../../../Model/Network/Config/Axios";
import { FloatSelect, DeltaFloatInput } from "../FloatLabelInput";
import { showToast } from "../../fToast/ToastCallback";
import FindMaster from './Master';
import { FloatFile } from '../FloatLabelInput/FloatFile';
import { MultiselectDropDown } from './MultiSelect';
import _ from 'lodash';
import checkIcon from '../FloatLabelInput/icons8-checked-checkbox-80.png';
import MultiMaster from './MultiMaster';
import moment from 'moment';
import ProductSearch from '../../../Pages/fCommon/Submit/ProductSearch';
import SearchEndPoint from './SearchEndPoint';

class Form2 extends React.Component {

	constructor(props) {
		super(props);
		this.productMasterREF = React.createRef();
		this.state = {
			forms: [],
			master: this.props.masterKeyValue ? { ...this.props.masterKeyValue } : {},
			dependentKeyValue: this.props.dependentKeyValue ? this.props.dependentKeyValue : {},
			updateItem: {
				key: '',
				value: ''
			},
			loading:false
		}
	}

	autoFillKeyObjectValue = {}

	componentDidUpdate(prev) {
		if (!_.isEqual(this.props.dependentKeyValue, prev.dependentKeyValue)) {
			this.setState({
				...this.state,
				dependentKeyValue: this.props.dependentKeyValue
			})
		}
	}
	componentDidMount() {
		if (this.props.handler) {
			this.props.handler(this)
		}
	}


	// checkDependableCondition = (value) => {
	// 	if (this.state.dependentKeyValue[value.first] === value.second) {
	// 		return true
	// 	}
	// 	return false
	// }

	checkDependableCondition = (value) => {
		if(value && value.first && value.second) {
			let dependencyKeys=value.first.split("||");
			let dependencyValues=value.second.split("||");
			for(let i=0;i<dependencyKeys.length;i++) {
				let key=dependencyKeys[i].trim();
				let value=dependencyValues[i].trim();
				if(this.state.dependentKeyValue[key]!==value) {
					return false
				}
			}
			return true
		}
		return false;
    }


	checkDependableForm = (item) => {
		if (item.dependentField && Object.keys(item.dependentField).length > 0) {
			return this.checkDependableCondition(item.dependentField)
		}
		return true
	}

	setInitialFieldValues = (initialValues) => {
		
		const form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			const field = form[i];
			const type = field.type;
			let initialValue = initialValues[field.fieldId];
			if (!initialValue) {
				initialValue = initialValues[field.name]
			}
			
			if (initialValue !== undefined && this.checkDependableForm(field)) {
				if(field.masterType && field.masterType.toLowerCase()==='product'){
					this.productMasterREF.current.setValue({title:initialValue});
				}
				else if (type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER') {
					this[`field:${field.id}`].value = initialValue;
				}else if(type === 'DATE'){
					this[`field:${field.id}`].value = moment(initialValue,"DD-MM-YYYY").format("YYYY-MM-DD");;
				}else {
					const fieldRef = this[`field:${field.id}`];
					if (fieldRef && typeof fieldRef.setValue === 'function') {
						if(type==="MULTISELECT"){
							let items = initialValue.split(";").map((item)=>{return {label:item,value:item}});
							fieldRef.setValue(items);
						}
						else{
							fieldRef.setValue(initialValue);
						}
					}
					if(type === "MASTER"){
						let master = { ...this.state.master };
						let key = field.next;
						master[key] = initialValue;
						this.setState((prev)=>{
							return({
								...prev,
								master,
								dependentKeyValue: {
									...this.state.dependentKeyValue,
									[field.fieldId]: initialValue
								}
							})
						})
					}
				}
			}
		}
	};

	clear = () => {
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			this[`field:${field.id}`].value = ""
		}
	}

	getKeyValue = (cb) => {
		if(this.state.loading){
			showToast({
				type:'error',
				message:'Custom forms are loading, please wait...'
			})
			return;
		}
		let data = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined
			if (this.checkDependableForm(field)) {
				if(field.masterType && field.masterType.toLowerCase()==='product'){
					let val=this.productMasterREF.current.getValue();
					if(val){
						value=val.title
					}
				}
				else if (type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER' || type === 'DATE') {
					value = this[`field:${field.id}`].value;
				} else {
					value = this[`field:${field.id}`].getValue();
				}
			} else {
			}
			if (value) {
				data[field.id] = value
			} else if (field.required && Object.keys(field.dependentField).length > 0) {
				if (this.checkDependableForm(field) && !value) {
					showToast({
						type: 'error',
						message: `${field.name} is marked required`
					})
					return
				} else {
					data[`${field.id}`] = "";
				}
			} else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if (!field.required && !value) {
				data[`${field.id}`] = "";
			}
		}
		cb(data)
	}

	getFieldValePair = (cb) => {
		let data = {}
		let formData = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined
			if (this.checkDependableForm(field)) {
				if (type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER' || type === 'DATE') {
					value = this[`field:${field.id}`].value;
				} else {
					value = this[`field:${field.id}`].getValue();
				}
			} else {
			}
			if (value) {
				data[field.fieldId] = value
				formData[field.id] = value
			} else if (field.required && Object.keys(field.dependentField).length > 0) {
				if (this.checkDependableForm(field) && !value) {
					showToast({
						type: 'error',
						message: `${field.name} is marked required`
					})
					return
				} else {
					data[`${field.fieldId}`] = "";
					formData[field.id] = "";
				}
			} else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if (!field.required && !value) {
				data[`${field.fieldId}`] = "";
				formData[field.id] = "";
			}
		}

		cb(data, formData)
	}

	getCustomFormKeyValue = (cb) => {
		let data = {}
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let type = field.type;
			let value = undefined
			if (this.checkDependableForm(field)) {
				if (type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER' || type === 'DATE') {
					value = this[`field:${field.id}`].value;
				} else {
					value = this[`field:${field.id}`].getValue();
				}
			}

			if (value) {
				data[field.id] = { "value": value, "name": field.name, "key": field.fieldId }
			} else if (field.required && Object.keys(field.dependentField).length > 0) {
				if (this.checkDependableForm(field) && !value) {
					showToast({
						type: 'error',
						message: `${field.name} is marked required`
					})
					return
				} else {
					data[`${field.id}`] = { "value": "", "name": field.name, "key": field.fieldId }
				}
			} else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if (!field.required && !value) {
				data[field.id] = { "value": "", "name": field.name, "key": field.fieldId }
			}
		}
		cb(data)
	}

	getForm = (cb) => {
		let data = []
		let form = this.state.forms;
		for (let i = 0; i < form.length; i++) {
			let field = form[i];
			let value = undefined;
			let type = field.type;

			if (this.checkDependableForm(field)) {
				if (type === 'TEXT' || type === 'EMAIL' || type === 'NUMBER' || type === 'DATE') {
					value = this[`field:${field.id}`].value;
				} else {
					value = this[`field:${field.id}`].getValue();
				}
			}

			if (value) {
				data.push({ "value": value, "name": field.name, "key": field.name, id: field.id })
			}
			else if (field.required && Object.keys(field.dependentField).length > 0) {
				if (this.checkDependableForm(field) && !value) {
					showToast({
						type: 'error',
						message: `${field.name} is marked required`
					})
					return
				} else {
					data.push({ "value": "", "name": field.name, "key": field.name, id: field.id })

				}
			} else if (field.required) {
				if (!value) {
					showToast({
						type: 'error',
						message: `${field.name} is required`
					})
					return
				}
			} else if (!field.required && !value) {
				data.push({ "value": "", "name": field.name, "key": field.name, id: field.id })
			}


		}
		cb(data)
	}


	loadForm = (key) => {
		this.setState({ loading: true });
		get(`/forms/${key}`, (e, r) => {
			if (r) {
				if(this.props && this.props.setLineItemForms){
					this.props.setLineItemForms((prev)=>({...prev, [key]: r}));
				}
				this.setState({
					...r,
					loading:false
				}, () => {
					if (this.props.initialValues && Object.keys(this.props.initialValues).length > 0)
						this.setInitialFieldValues(this.props.initialValues)
				})
			} else {
				this.setState({ loading: false });
			}
		})
	}

	isLoading = () => this.state.loading;

	customForm = (forms) => {
		this.setState({
			...this.state,
			forms,
			loading:false
		}, () => {
			if (this.props.initialValues && Object.keys(this.props.initialValues).length > 0)
				this.setInitialFieldValues(this.props.initialValues)
		})
	}

	mapItem = (item, index) => {
		let editable=(item && ("editable" in item)) ? item.editable : true;
		let type = item.type.toLowerCase();
		let masterType =item.masterType? item.masterType.toLowerCase():null;
		if(masterType==='product'){
		return (
      <ProductSearch
		disabled={!editable}
		categoryId={this.props.categoryId}
        apiType={this.props.tenant === "STELMC" ? "post" : "get"}
        extraData={{
          formData: {
            pr_iom: "Manual PR",
          },
        }}
        placeholder={item.placeholder}
        ref={this.productMasterREF}
        onSelect={(p) => {
          this.props.updateForm(item.fieldId, p.title, item.name,item.id);
        }}
      />
    );
	}
		else if ((type === 'email' || type === 'number' || type === 'text' || type === 'date') && this.checkDependableForm(item)) {
			if (item.type === 'TEXT' && item.masterType) {
				return (
					<div className="full-width" style={{ position: 'relative' }}>
					<SearchEndPoint
						disabled={!editable}
						allowSpecialCharacters={item.fieldId === 'invoice no' || item.fieldId === 'description' ? true : true}
						defaultValue={this.props.initialValues[item.fieldId]}
						key={item.id}
						className='mt2'
						label={item.name}
						type={item.type.toLowerCase()}
						placeholder={item.placeholder}
						masterType={item.masterType}
						onUpdate={(value) => {
							this.setState({
								...this.state,
								updateItem: {
									key: item.fieldId,
									value
								}
							})
						}}
						filterData={this.state.FilterData}
						ref={ref => this[`field:${item.id}`] = ref}
					/>
					{(this.state.updateItem && this.state.updateItem.key === item.fieldId) ? (
						<div onClick={() => { this.props.updateForm(this.state.updateItem.key, this.state.updateItem.value, item.name,item.id); this.setState({ ...this.state, updateItem: {} }) }} style={{ position: "absolute", right: 1, top: 36, cursor: 'pointer' }}><img alt='check icon' height={48} src={checkIcon} /></div>
					) : null}
					</div>

				)
			}
			return (
				<DeltaFloatInput
					diasblePrev={(item.type.toLowerCase() === "date" && item.min === 1) ? true : undefined}
					maxLength={item.max}
					min={item.min}
					max={(type === "date" && item.futureDateAllowed === false) ? moment().format("YYYY-MM-DD") : undefined}
					key={item.id}
					disabled={!editable}
					title={item.name ? item.name : item.placeholder}
					placeholder={item.placeholder}
					type={item.type.toLowerCase()}
					update={(val) => {
						if(type === "date"){
							this.props.updateForm(item.fieldId, moment(val,"YYYY-MM-DD").format("DD-MM-YYYY"),item.name,item.id)
						}else this.props.updateForm(item.fieldId, val, item.name,item.id)
					}}
					handleRef={({ ref }) => {
						this[`field:${item.id}`] = ref;
					}} />)
		} else if (type === "select" && this.checkDependableForm(item)) {
			
			return (
				<div className="full-width" style={{ position: 'relative' }}>
					<FloatSelect
						disabled={!editable}
						firstValue={true}
						key={index}
						title={item.name}
						onChange={(value) => {
							this.setState({
								...this.state,
								// isPrefill:false,
								dependentKeyValue: {
									...this.state.dependentKeyValue,
									[item.fieldId]: value
								},
								updateItem: {
									key: item.fieldId,
									value
								}
							})
						}}
						items={item.values}
						handleRef={(ref) => this[`field:${item.id}`] = ref}
					/>
					{(this.state.updateItem && this.state.updateItem.key === item.fieldId) ? (
						<div onClick={() => { this.props.updateForm(this.state.updateItem.key, this.state.updateItem.value,item.name,item.id); this.setState({ ...this.state, updateItem: {} }) }} style={{ position: "absolute", right: -2, top: 34, cursor: 'pointer' }}><img alt='check icon' height={48} src={checkIcon} /></div>
					) : null}

				</div>
			)
		} else if (type === "multiselect") {
			return (
				<>
					<MultiselectDropDown
						disabled={!editable}
						key={index}
						title={item.name}
						options={item.values.map(j => ({ value: j.value, label: j.key }))}
						handleRef={ref => this[`field:${item.id}`] = ref}
					/>
					<div style={{display: 'flex', alignItems: 'center', gap: '10px',margin:'5px 0'}}>
						<label>Update Values</label>
						<input disabled={!editable} type='checkbox' onChange={()=>{
							this.props.updateForm(item.fieldId, this[`field:${item.id}`].getValue(), item.name,item.id);
						}} />
					</div>
					{
						this.props.initialValues && this.props.initialValues[item.fieldId] && this.props.initialValues[item.fieldId].split(";").map(j => {
							return (
								<input id="FieldInput" min="1" autocomplete="off" class="field__input small_input" placeholder="DEFAULT" value={j} style={{fontSize: '12px', height: '40px', width: '100%', padding: '10px', margin:'4px 0'}}/>
							)
						})
					} 
				</>
			)
		} else if (type === 'file') {
			return (
				<>
				<FloatFile
					disabled={!editable}
					key={index}
					title={item.name}
					required={item.required}
					placeholder={`Select File`}
					handleRef={ref => this[`field:${item.id}`] = ref}
					defaultValue={this.props.initialValues[item.fieldId]}
				/>
				{this.props.initialValues && this.props.initialValues[item.fieldId] && 
				<span onClick={()=>{window.open(this.props.initialValues[item.fieldId],'_blank')}} 
				  style={{cursor: 'pointer',color: 'var(--primary-color)',fontWeight: 600}}>Open Attachment</span>
				}
		  	</>
			)
		}else if(item.type==='MULTIMASTER' && this.checkDependableForm(item)) {
			return (
				<div className="full-width" style={{ position: 'relative' }}>
					<MultiMaster
						disabled={!editable}
						key={item.id}
						master={this.state.master}
						handleRef={ref => this[`field:${item.id}`] = ref}
						details={item}
						fieldId={item.fieldId ? item.fieldId : item.name}
						label={`${item.name} ${item.required ? '*' : ''}`}
						placeholder={item.placeholder}
						defaultValue={this.props.initialValues[item.fieldId]}
						onUpdate={(i, next) => {
							let master = { ...this.state.master };
							let key = next ? next : item.next;
							let val = i.map(el => el.value);
							master[key] = val.join("::");
							if (this.props.updateForm) {
								this.setState({
									...this.state,
									master,
									dependentKeyValue: {
										...this.state.dependentKeyValue,
										[item.fieldId]: val.join("::")
									},
									updateItem: {
										key: item.fieldId,
										value: val.join("::")
									}
								})
							} else {
								this.setState({
									...this.state,
									master,
									dependentKeyValue: {
										...this.state.dependentKeyValue,
										[item.fieldId]: val.join("::")
									}
								})
							}
						}}


					/>
					{(this.state.updateItem && this.state.updateItem.key === item.fieldId) ? (
						<div onClick={() => { this.props.updateForm(this.state.updateItem.key, this.state.updateItem.value, item.name,item.id); this.setState({ ...this.state, updateItem: {} }) }} style={{ position: "absolute", right: -3, top: 14, cursor: 'pointer' }}><img alt='check icon' height={48} src={checkIcon} /></div>
					) : null}
				</div>
			)
	   } else if (type === 'master' && this.checkDependableForm(item)) {
			return (
				<div className="full-width" style={{ position: 'relative' }}>
					<FindMaster
					disabled={!editable}
					key={index}
					title={item.name}
					required={item.required}
					placeholder={`Search the ${item.placeholder}`}
					handleRef={ref => this[`field:${item.id}`] = ref}
					fieldId={item.fieldId ? item.fieldId : item.name}
					details={item}
					onUpdate={async (i, next) => {
						let master = { ...this.state.master };
						let key = next
						master[key] = i[key];
						if(this.props.updateForm){
							this.setState({
								...this.state,
								master,
								dependentKeyValue: {
									...this.state.dependentKeyValue,
									[item.fieldId]: i[key]
								},
								updateItem: {
									key: item.fieldId,
									value: i[key]
								}
							})
						}else{
							this.setState({
								...this.state,
								master,
								dependentKeyValue: {
									...this.state.dependentKeyValue,
									[item.fieldId]: i[key]
								}
							})
						}

						let obj={};
						// Prefill fields and notify parent so values survive when API returns and initialValues update
						Object.keys(i).forEach(insideItem=>{
							let mItem = this.autoFillKeyObjectValue && this.autoFillKeyObjectValue[insideItem];
							if(mItem) {
								const value = i[insideItem] || "";
								if(mItem.type==='TEXT' && this[`field:${mItem.id}`]) {
									this[`field:${mItem.id}`].value = value;
									obj[mItem.fieldId] = value;
								}
							}
						})
						if(obj && Object.keys(obj).length > 0) {
							obj[item.fieldId] = i[key];
							let keys = Object.keys(obj);
							for(let i=0;i<keys.length;i++){
								let key = keys[i];
								let value = obj[key];
								if(i===keys.length-1){
									await this.props.updateForm(key, value,false);
								}
								else{
									await this.props.updateForm(key, value,true);
								}
							}
							this.setState({ ...this.state, updateItem: {} })
						}
						// if(this.props.updateForm) this.props.updateForm(item.fieldId, i[key])
					}}
					defaultValue={this.props.initialValues[item.fieldId]}
					master={this.state.master}
				/>
				{(this.state.updateItem && this.state.updateItem.key === item.fieldId) ? (
						<div onClick={() => { this.props.updateForm(this.state.updateItem.key, this.state.updateItem.value, item.name,item.id); this.setState({ ...this.state, updateItem: {} }) }} style={{ position: "absolute", right: 1, top: 28, cursor: 'pointer' }}><img alt='check icon' height={48} src={checkIcon} /></div>
					) : null}
				</div>
			)
		}


	}

	render() {

		for (let item in this.state.forms) {
			let mItem = this.state.forms[item];
			if (mItem.autofill || mItem.autoFill) {
				this.autoFillKeyObjectValue[mItem.fieldId] = mItem;
			}
		}

		return (
			<div>
				{this.state.forms.length > 0 ?
					<p style={{ margin: '10px 0px', fontSize: 16, fontWeight: 600 }}>
						{this.props.title && this.props.service ?
							`${this.props.title}-${this.props.service} Line Item Field`
							: this.props.service ? `${this.props.service} Line Item Field` : this.props.label ? this.props.label : 'Additional Details'}</p> : null}
				<p style={{ margin: '10px 0px', fontSize: 14, fontWeight: 300 }}>
					{this.state.forms.length > 0 && this.props.desc ? this.props.desc : null}
				</p>
				{
					this.state.forms.map(this.mapItem)
				}
			</div>
		)
	}

}

export {
	Form2
}
